<template>
  <div class="save">
    <div class="box">
      <h1>Údaje o vozidle</h1>
      <div class="row">
        <h2>Jednotka</h2>
        <h2>{{ idUnit }}</h2>
      </div>
      <div class="row">
        <h2>Základní kontrola</h2>
        <div class="icon" v-bind:class="{ success: result && checkBasic }">
          <CheckIcon v-if="checkBasic" /><CrossIcon v-else />
        </div>
      </div>
      <div class="row">
        <h2>Kontrola CAN</h2>
        <div
          class="icon"
          v-bind:class="{ success: result && checkCan == 1 }"
          v-if="checkCan == 1 || checkCan == 2"
        >
          <CheckIcon v-if="checkCan == 1" /><CrossIcon v-else />
        </div>
        <template v-else>
          <div class="icon grey">
            <CircleIcon />
          </div>
        </template>
      </div>
<!--      <div class="row">-->
<!--        <h2>Kontrola Tacho</h2>-->
<!--        <div-->
<!--          class="icon"-->
<!--          v-bind:class="{ success: result && checkTacho == 1 }"-->
<!--          v-if="checkTacho == 1 || checkTacho == 2"-->
<!--        >-->
<!--          <CheckIcon v-if="checkTacho == 1" /><CrossIcon v-else />-->
<!--        </div>-->
<!--        <template v-else>-->
<!--          <div class="icon grey">-->
<!--            <CircleIcon />-->
<!--          </div>-->
<!--        </template>-->
<!--      </div>-->
    </div>

    <form v-on:submit.prevent="saveSubmit" class="form">
      <div class="row">
        <label for="client">Firma</label>
        <autocomplete
          ref="clientField"
          :search="searchCompany"
          :get-result-value="getResultSearchCompany"
          id="client"
          name="client"
          tabindex="1"
        ></autocomplete>
      </div>
      <div class="row">
        <label for="name">Název vozidla</label>
        <input
          type="text"
          id="name"
          name="name"
          tabindex="2"
          v-model="name"
          required
          autocomplete="off"
        />
      </div>
      <div class="row">
        <label for="plate">SPZ</label>
        <input
          type="text"
          id="plate"
          name="plate"
          tabindex="3"
          v-model="plate"
          required
          autocomplete="off"
          autocapitalize="characters"
        />
      </div>
      <div class="row">
        <label for="hasTachometer" class="checkboxLabel"
          >Vozidlo má tachometr
          <span v-bind:class="{ on: hasTachometer, 'switch-btn': true }"></span
        ></label>
        <input
          type="checkbox"
          id="hasTachometer"
          name="hasTachometer"
          tabindex="5"
          v-model="hasTachometer"
        />
      </div>
      <div class="row">
        <label for="tachometer">Tachometr</label>
        <div class="tachometerInput">
          <input
            type="number"
            inputmode="numeric"
            pattern="[0-9]*"
            id="tachometer"
            name="tachometer"
            tabindex="6"
            v-model="tachometer"
            v-bind:disabled="!hasTachometer"
            autocomplete="off"
          />
          <span>km</span>
        </div>
      </div>
      <div class="row">
        <label>Barva</label>
        <div class="color">
          <span class="spot" v-bind:style="{ background: getColorCode }"></span>
          <v-select v-model="color" :options="colors" label="name">
            <template v-slot:option="color">
              <span
                class="point"
                v-bind:style="{ background: color.code }"
              ></span>
              {{ color.name }}
            </template>
          </v-select>
        </div>
      </div>
      <div class="row">
        <label>Typ</label>
        <div class="icons">
          <button
            type="button"
            v-on:click="setType(0)"
            v-bind:class="{ selected: type === 0 }"
          >
            <SmallIcon />
          </button>
          <button
            type="button"
            v-on:click="setType(1)"
            v-bind:class="{ selected: type === 1 }"
          >
            <SedanIcon />
          </button>
          <button
            type="button"
            v-on:click="setType(2)"
            v-bind:class="{ selected: type === 2 }"
          >
            <CombiIcon />
          </button>
          <button
            type="button"
            v-on:click="setType(3)"
            v-bind:class="{ selected: type === 3 }"
          >
            <VanIcon />
          </button>
          <button
            type="button"
            v-on:click="setType(4)"
            v-bind:class="{ selected: type === 4 }"
          >
            <BusIcon />
          </button>
          <button
            type="button"
            v-on:click="setType(5)"
            v-bind:class="{ selected: type === 5 }"
          >
            <TruckIcon />
          </button>
        </div>
      </div>
      <div class="row">
        <label for="note">Poznámka</label>
        <input
          type="text"
          id="note"
          name="note"
          tabindex="10"
          v-model="note"
          autocomplete="off"
        />
      </div>
      <div class="row">
        <label for="additionalInfo" class="checkboxLabel">Další info
          <span v-bind:class="{ on: additionalInfo, 'switch-btn': true }"></span
          ></label>
        <input
            type="checkbox"
            id="additionalInfo"
            name="additionalInfo"
            tabindex="5"
            v-model="additionalInfo"
        />
      </div>
      <div
          v-bind:class="{ visible: additionalInfo, additional: true, row: true }"
      >
        <div class="row">
          <label for="typeMontage">Typ montáže</label>
          <div class="select">
            <select id="typeMontage" v-model="typeMontage">
              <option value="1">Standardní montáž</option>
              <option value="2">Montáž včetně identifikace</option>
              <option value="3">Montáž včetně CAN</option>
              <option value="4">Demontáž</option>
              <option value="5">Jiný (poznámka)</option>
            </select>
          </div>
        </div>
        <div class="row">
          <label for="price">Cena montáže</label>
          <input
              type="text"
              id="price"
              name="price"
              tabindex="8"
              v-model="price"
              autocomplete="off"
          />
        </div>
        <div class="row">
          <label for="km">Účtovaný počet km</label>
          <input
              type="text"
              id="km"
              name="km"
              tabindex="9"
              v-model="km"
              autocomplete="off"
          />
        </div>
    </div>
    <div class="row" v-if="!this.detail">
        <button type="submit" tabindex="3" v-bind:disabled="checkContinue">
          Odeslat
        </button>
      </div>
      <div class="row" v-if="info">
        <p class="error" v-html="info"></p>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "../store";
import SmallIcon from "@/icons/SmallIcon.vue";
import SedanIcon from "@/icons/SedanIcon.vue";
import CombiIcon from "@/icons/CombiIcon.vue";
import VanIcon from "@/icons/VanIcon.vue";
import BusIcon from "@/icons/BusIcon.vue";
import TruckIcon from "@/icons/TruckIcon.vue";
import CrossIcon from "@/icons/CrossIcon.vue";
import CheckIcon from "@/icons/CheckIcon.vue";
import CircleIcon from "@/icons/CircleIcon.vue";

export default {
  name: "Save",
  props: ["unit"],
  mounted() {
    document.title = "GPS Dozor Servis";

    if (this.unit) {
      this.edit = this.unit.editable;
      this.detail = !this.unit.editable;
      this.client = this.unit.client;
      this.name = this.unit.name;
      this.plate = this.unit.plate;
      this.color = this.colors[this.unit.color];
      this.type = this.unit.type;
      this.tachometer = this.unit.tachometer;
      this.typeMontage = this.unit.typeMontage;
      this.price = this.unit.priceMontage;
      this.km = this.unit.accountKm;
      this.note = this.unit.note;
      this.hasTachometer = this.unit.tachometer !== "";
      this.id = this.unit.id;

      if (!store.state.checkResult) {
        store.state.checkResult = {};
      }
      store.state.checkResult.controlCan = this.unit.checkCan;
      if (this.unit.checkCan > 0) {
        store.state.checkResult.isValidCan = this.unit.checkCan;
      }
      store.state.checkResult.controlTacho = this.unit.checkTacho;
      if (this.unit.checkTacho > 0) {
        store.state.checkResult.isValidTacho = this.unit.checkTacho;
      }
      store.state.checkResult.isValidBasic = this.unit.checkBasic;

      if (this.$refs.clientField) {
        this.$refs.clientField.setValue(this.client);
      }
    } else {
      this.checkStart();
    }

    if (store.state.role == 2) {
      this.$router.push("history");
      return;
    }
  },
  components: {
    SmallIcon,
    SedanIcon,
    CombiIcon,
    VanIcon,
    BusIcon,
    TruckIcon,
    CheckIcon,
    CrossIcon,
    CircleIcon
  },
  computed: {
    idUnit() {
      return store.state.idUnit;
    },
    result() {
      if (store.state.checkResult && store.state.checkResult.controlCan) {
        if (store.state.checkResult.isValidCan) {
          this.checkCan = 1;
        } else {
          this.checkCan = 2;
        }
      }

      if (store.state.checkResult && store.state.checkResult.controlTacho) {
        if (store.state.checkResult.isValidTacho) {
          this.checkTacho = 1;
        } else {
          this.checkTacho = 2;
        }
      }

      this.checkBasic =
        store.state.checkResult && store.state.checkResult.isValidBasic;

      if (store.state.checkResult && store.state.checkResult.edit) {
        this.edit = true;
        this.id = store.state.checkResult.unit.id;
        this.client = store.state.checkResult.unit.client;
        this.name = store.state.checkResult.unit.name;
        this.plate = store.state.checkResult.unit.plate;
        this.color = this.colors[store.state.checkResult.unit.color];
        this.type = store.state.checkResult.unit.type;
        this.tachometer = store.state.checkResult.unit.tachometer;
        this.typeMontage = store.state.checkResult.unit.typeMontage;
        this.price = store.state.checkResult.unit.priceMontage;
        this.km = store.state.checkResult.unit.accountKm;
        this.note = store.state.checkResult.unit.note;
        this.hasTachometer = store.state.checkResult.unit.tachometer !== "";

        if (this.$refs.clientField) {
          this.$refs.clientField.setValue(this.client);
        }
      }

      return store.state.checkResult;
    },
    checkContinue() {
      //if(this.client === "") return true;
      if (this.name === "") return true;
      if (this.plate === "") return true;
      if (this.type === "") return true;
      if (this.color === 0) return true;
      if (this.hasTachometer && this.tachometer === "") return true;
      return false;
    },
    getColorCode() {
      if (this.color == null) {
        return "";
      }
      return this.color.code;
    }
  },
  data: function() {
    return {
      edit: false,
      detail: false,
      client: "",
      name: "",
      plate: "",
      color: 0,
      type: 0,
      hasTachometer: true,
      tachometer: "",
      info: null,
      colors: [
        {
          id: 0,
          code: "#71706B",
          name: "Šedá/bílá"
        },
        {
          id: 1,
          code: "#5096C8",
          name: "Modrá"
        },
        {
          id: 2,
          code: "#000000",
          name: "Černá"
        },
        {
          id: 3,
          code: "#6CA534",
          name: "Zelená"
        },
        {
          id: 4,
          code: "#FF4E69",
          name: "Růžová"
        },
        {
          id: 5,
          code: "#F1C40F",
          name: "Žlutá"
        }
      ],
      additionalInfo: false,
      typeMontage: 0,
      price: "",
      km: "",
      note: "",
      checkCan: 0,
      checkTacho: 0,
      checkBasic: false,
      id: null
    };
  },
  methods: {
    setType: function(id) {
      this.type = id;
    },
    saveSubmit: async function() {
      store.commit("showLoading");

      let result;

      if (this.edit) {
        const unit = {
          client: this.client,
          name: this.name,
          plate: this.plate,
          color: parseInt(this.color.id),
          type: parseInt(this.type),
          hasTachometer: this.hasTachometer,
          tachometer: parseInt(this.tachometer),
          typeMontage: parseInt(this.typeMontage),
          price: this.price,
          km: this.km,
          note: this.note,
          checkCan: this.checkCan,
          checkTacho: this.checkTacho,
          checkBasic: this.checkBasic,
          id: this.id
        };

        if (!store.state.companies.includes(this.client)) {
          store.state.companies.push(this.client);
        }

        result = await store.dispatch("getUnit", {
          unit: unit
        });
        if (result.editable) {
          result = await store.dispatch("editUnit", {
            unit: unit
          });
        } else {
          alert("Bohužel již nejde tuto jednotku upravovat.");
        }
      } else {
        result = await store.dispatch("save", {
          client: this.client,
          name: this.name,
          plate: this.plate,
          color: parseInt(this.color.id),
          type: parseInt(this.type),
          hasTachometer: this.hasTachometer,
          tachometer: parseInt(this.tachometer),
          typeMontage: parseInt(this.typeMontage),
          price: this.price,
          km: this.km,
          note: this.note,
          checkCan: this.checkCan,
          checkTacho: this.checkTacho,
          checkBasic: this.checkBasic,
          originalId: null
        });
        if (!store.state.companies.includes(this.client)) {
          store.state.companies.push(this.client);
        }
      }

      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      if (result) {
        store.commit("saveState");
        this.$router.push("finish");
      } else {
        this.info = "Chyba";
      }
    },
    checkStart: function() {
      if (store.state.checkResult === null) {
        this.$router.push("check");
        return;
      }
    },
    searchCompany: function(input) {
      let companies = [];
      if (store.state.companies) {
        companies = store.state.companies;
      }

      if (input.length < 1) {
        return [];
      }
      this.client = input;
      return companies.filter(company => {
        return company.toLowerCase().startsWith(input.toLowerCase());
      });
    },
    getResultSearchCompany: function(result) {
      this.client = result;
      return result;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/1-base/variables";
@import "~vue-select/dist/vue-select.css";
@import "~@trevoreyre/autocomplete-vue/dist/style.css";

h1 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 24px;
}

.checkboxLabel {
  //text-align: center;
  cursor: pointer;

  display: flex;
  justify-content: space-between;

  //svg{
  //  height: 30px;
  //  width: 30px;
  //  position: relative;
  //  margin-bottom: -9px;
  //  margin-top: -6px;
  //  margin-left: 4px;
  //}
  //
  //.red{
  //  color: @red;
  //}
  //.green{
  //  color: @green;
  //}
}

.tachometerInput {
  display: flex;
  align-items: center;

  span {
    margin-left: 4px;
  }
}

.point {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: relative;
  margin-left: 4px;
  top: 4px;
  border-radius: 50%;
}

.color {
  position: relative;
  border: 1px solid #d3d6e5;
  padding: 10px 10px 10px 30px;
  border-radius: 8px;

  .spot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 50%;
    background-color: transparent;
  }
}

.icons {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: -2% -1%;

  button {
    width: 30%;
    margin: 2% 1%;
    padding: 20px 0;
    background-color: #fff;
    color: @blue;
    border: 1px solid @blue;

    svg {
      transform: scale(2);
    }

    &.selected {
      background-color: @blue;
      color: @white-common;
    }
  }
}

.additional {
  display: none;

  &.visible {
    display: block;
  }
}

.box {
  padding-top: 14px;
  padding-bottom: 14px;
  &:first-child {
    margin-top: 0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: 30px;
  }

  h2,
  h3 {
    text-align: left;
    margin: 0;
    font-size: 14px;

    span {
      position: relative;
      margin-left: 4px;
      width: 18px;
      display: inline-block;
      height: auto;
      vertical-align: top;
      svg {
        position: absolute;
        top: -4px;
        left: 0;
        width: 18px;
      }
    }

    button {
      padding: 4px;
      width: auto;
      font-size: 14px;
      border-radius: 4px;
      margin-left: 4px;
    }
  }

  h3 {
    font-size: 14px;
    font-weight: 400;
  }

  h1 {
    text-align: center;
    margin-bottom: 20px;
  }

  .icon {
    color: @red;
    svg {
      width: 30px;
    }
    &.success {
      color: @green;
    }
    &.grey {
      color: @black;
    }
  }
}
</style>

<style>
.vs__clear {
  width: auto;
  color: #524b47;
}

.vs__clear:hover {
  color: #524b47;
  background-color: transparent;
}

.vs__dropdown-toggle {
  border: 0;
}

.vs__search {
  width: 0 !important;
}
</style>
